import { formatLocaleData } from "../formatLocale";

const getDynamicHomeValue = (data, locale) => {
    let title = data?.title;
    let content = data?.content;
    if (data?.dynamicBanner && data.dynamicBanner.length > 0) {
        const dynamicValue = data.dynamicBanner.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            title = dynamicValue.title || title;
            content = dynamicValue.content || content;
        }
    }

    return { title, content };
};

export default getDynamicHomeValue;

export const dynamicLocationValue = (data, locale) => {
    let location = data?.location;

    if (data?.dynamicPopularLocation && data.dynamicPopularLocation.length > 0) {
        const dynamicValue = data.dynamicPopularLocation.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            location = dynamicValue.location || location;
        }
    }
    return { location };
};

export const dynamicImageBannerValue = (data, locale) => {
    let title = data?.title;
    let content = data?.content;
    let buttonLabel = data?.buttonLabel;
    let buttonLabel2 = data?.buttonLabel2;
    if (data?.dynamicImageBanner && data.dynamicImageBanner.length > 0) {
        const dynamicValue = data.dynamicImageBanner.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            title = dynamicValue.title || title;
            content = dynamicValue.content || content;
            buttonLabel = dynamicValue.buttonLabel || buttonLabel;
            buttonLabel2 = dynamicValue.buttonLabel2 || buttonLabel2;
        }
    }
    return { title, content, buttonLabel, buttonLabel2 };
}

export const dynamicFooterValue = (data, locale) => {
    let title1 = data?.title1;
    let content1 = data?.content1;
    let title2 = data?.title2;
    let content2 = data?.content2;
    let title3 = data?.title3;
    let content3 = data?.content3;

    if (data?.dynamicFooterBlock && data.dynamicFooterBlock.length > 0) {
        const dynamicValue = data.dynamicFooterBlock.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            title1 = dynamicValue.title1 || title1;
            content1 = dynamicValue.content1 || content1;
            title2 = dynamicValue.title2 || title2;
            content2 = dynamicValue.content2 || content2;
            title3 = dynamicValue.title3 || title3;
            content3 = dynamicValue.content3 || content3;
        }
    }
    return { title1, content1, title2, content2, title3, content3 };
}

export const dynamicBlogValue = (data, locale) => {
    let pageTitle = data?.pageTitle;
    let content = data?.content;
    let metaTitle = data?.metaTitle;
    let metaDescription = data?.metaDescription;

    if (data?.dynamicBlogDetails && data.dynamicBlogDetails.length > 0) {
        const dynamicValue = data.dynamicBlogDetails.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            pageTitle = dynamicValue.pageTitle || pageTitle;
            content = dynamicValue.content || content;
            metaTitle = dynamicValue.metaTitle || metaTitle;
            metaDescription = dynamicValue.metaDescription || metaDescription;
        }
    }
    return { pageTitle, content, metaTitle, metaDescription };
}

const dynamicFieldMap = {
    carTripTitle1: 'title',
    carTripTitle2: 'title',
    carTripTitle3: 'title',
    carTripContent2: 'content',
    carTripContent3: 'content'
};

export const dynamicStaticInfoValue = (name, value, dynamicStaticInfoBlock, locale) => {
    if (dynamicStaticInfoBlock && dynamicStaticInfoBlock.length > 0) {
        const languageCode = formatLocaleData(locale);
        const matchedValue = dynamicStaticInfoBlock.find(item => item.language === languageCode)?.value;
        const fallbackValue = dynamicStaticInfoBlock[0]?.value;
        if (matchedValue || fallbackValue) return matchedValue || fallbackValue;
    }

    const valueKey = dynamicFieldMap[name];
    if (!valueKey || !value) return value;

    try {
        const parsedValue = JSON.parse(value);
        if (!Array.isArray(parsedValue)) return value;

        const languageCode = formatLocaleData(locale);
        const matchedValue = parsedValue.find(item => item?.language === languageCode)?.[valueKey];
        const fallbackValue = parsedValue?.[0]?.[valueKey];

        return matchedValue || fallbackValue || '';
    } catch (error) {
        return value;
    }
};

export const dynamicVehicleBlockValue = (data, locale) => {
    let value = data?.value;

    if (data?.dynamicFindYourVehicleBlock && data.dynamicFindYourVehicleBlock.length > 0) {
        const dynamicValue = data.dynamicFindYourVehicleBlock.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            value = dynamicValue.value || value;
        }
    }
    return value;
}

export const dynamicStaticPageValue = (data, locale) => {
    let content = data?.content;
    let metaTitle = data?.metaTitle;
    let metaDescription = data?.metaDescription;

    if (data?.dynamicStaticPage && data.dynamicStaticPage.length > 0) {
        const dynamicValue = data.dynamicStaticPage.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            content = dynamicValue.content || content;
            metaTitle = dynamicValue.metaTitle || metaTitle;
            metaDescription = dynamicValue.metaDescription || metaDescription;
        }
    }
    return { content, metaTitle, metaDescription };
}

export const dynamicWhyHostValue = (data, locale) => {
    let value = data?.value;

    if (data?.dynamicWhyHostInfoBlock && data.dynamicWhyHostInfoBlock.length > 0) {
        const dynamicValue = data.dynamicWhyHostInfoBlock.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            value = dynamicValue.value || value;
        }
    }
    return value;
}

export const dynamicAdminReviewValue = (data, locale) => {
    let userName = data?.userName;
    let reviewContent = data?.reviewContent;

    if (data?.dynamicAdminReviews && data.dynamicAdminReviews.length > 0) {
        const dynamicValue = data.dynamicAdminReviews.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            userName = dynamicValue.userName || userName;
            reviewContent = dynamicValue.reviewContent || reviewContent;
        }
    }
    return { userName, reviewContent };
}

export const getServicePlanValue = (data, locale) => {
    let planName = data?.planName;
    let description = data?.description;
    if (data?.dynamicServicePlans && data.dynamicServicePlans.length > 0) {
        const dynamicValue = data.dynamicServicePlans.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            planName = dynamicValue.planName || planName;
            description = dynamicValue.description || description;
        }
    }

    return { planName, description };
};

export const getPurchaseServicePlanValue = (data, locale) => {
    const languageCode = formatLocaleData(locale);
    const item = data?.find(item => item.language === languageCode);
    return {
        planName: item?.planName || '',
        description: item?.description || ''
    };
};

export const getPromoCodeValue = (data, locale) => {
    let title = data?.title;
    let description = data?.description;
    if (data?.dynamicPromoCode && data.dynamicPromoCode.length > 0) {
        const dynamicValue = data.dynamicPromoCode.find(item => item.language === formatLocaleData(locale));
        if (dynamicValue) {
            title = dynamicValue.title || title;
            description = dynamicValue.description || description;
        }
    }

    return { title, description };
};

export const getPromoCodeDetailsValue = (data, locale) => {
    const languageCode = formatLocaleData(locale);
    const item = data?.find(item => item.language === languageCode);
    return {
        title: item?.title || '',
        description: item?.description || ''
    };
};

